import React from 'react'
import Grid from '@material-ui/core/Grid'

import ApiRequest from 'EurestoApi/ApiRequest'

const project = require('EurestoConfig/project.config')

class Api extends React.Component {
  constructor (props) {
    super(props)
    this.state = {
      data: []
    }
  }

  componentDidMount () {
    this.getDataFromServer(project.api + this.props.method, this.props.dataSend)
  }

  showResult (response) {
    this.setState({
      data: response
    })
  }

  async getDataFromServer (URL, DATA) {
    const result = await ApiRequest(URL, DATA, { showAlertError: false, returnAnyway: true })
    this.showResult(result)
  }

  render () {
    if (this.state.data === undefined || this.state.data.code <= 0) {
      throw this.state.data.message
    } else if (this.state.data.code === 1) {
      return (<Grid container>
        <this.props.template {...this.props.props} data={this.state.data}/>
      </Grid>)
    } else {
      return <div/>
    }
  }
}

export default Api



// WEBPACK FOOTER //
// ./app/Utilitaire/Api/Api.js